<template>
  <div class="table-wrapper">
    <table v-if="currentReleaseData.length" class="release-table">
      <thead>
        <tr class="header">
          <th></th>
          <th>Data Series</th>
          <th>Reference period</th>
          <th>Impact</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(row, index) in currentReleaseData"
          :key="index"
          @click="$emit('row-click', index, row)"
        >
          <td class="color-cell">
            <div class="category-color-box-wrapper">
              <div
                :style="{ backgroundColor: colorForTable(row) }"
                class="category-color-box"
              ></div>
            </div>
          </td>
          <td class="title-cell" data-label="Data Series">
            {{ formatTitle(row.title) }}
          </td>
          <td data-label="Reference period">{{ row.referencePeriod }}</td>
          <td data-label="Impact">{{ formatImpactValue(row.impact) }}</td>
        </tr>
      </tbody>
    </table>
    <div v-else class="nodata-wrapper">
      <div>No new data releases</div>
    </div>
  </div>
</template>

<script>
import { mapState } from "pinia";
import { useDetailStore } from "@/stores/detail";

export default {
  name: "ReleaseTable",
  props: {
    activeCategories: {
      type: Array,
      required: true,
    },
  },
  computed: {
    ...mapState(useDetailStore, ["getReleaseData", "getActiveDay"]),
    getCategories() {
      const detailStore = useDetailStore();
      return detailStore.getCategories();
    },
    currentReleaseData() {
      let currentData = this.getReleaseData[this.getActiveDay] || [];
      currentData = currentData.toSorted(
        (a, b) => Math.abs(b.impact) - Math.abs(a.impact),
      );

      return currentData.filter((obj) => {
        return this.activeCategories.some((item) => item.name === obj.category);
      });
    },
  },
  methods: {
    colorForTable(data) {
      let category = data.category;
      if (category) {
        let catData = this.getCategories.find((obj) => obj.name === category);
        if (catData) {
          return catData["color"];
        }
      }
      return null;
    },
    formatValue(value) {
      if (typeof value === "number") {
        return value.toFixed(2);
      }
      return value;
    },
    formatImpactValue(value) {
      return Number.parseFloat(value).toPrecision(2);
    },
    formatTitle(title) {
      const maxLength = 15;
      return (
        title.slice(0, maxLength) + (maxLength < title.length ? "..." : "")
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.table-wrapper {
  width: 100%;
  position: relative;

  .release-table {
    width: 100%;
    font-size: 0.9em;

    .header {
      position: sticky;
      top: 0;
      background-color: rgb(var(--v-theme-surface));
      color: rgb(var(--v-theme-on-surface));
    }

    tr:hover td {
      background-color: rgba(var(--v-theme-on-surface), 0.06);
    }

    tr {
      border-bottom: 1px solid rgba(var(--v-theme-on-surface), 0.12);
    }

    td,
    th {
      white-space: nowrap;
      padding: 5px 15px;
    }

    td {
      cursor: pointer;
    }

    .category-color-box-wrapper {
      padding-top: 6px;

      .category-color-box {
        width: 11px;
        height: 11px;
      }
    }
  }

  .nodata-wrapper {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  @media (max-width: 600px) {
    .release-table {
      display: block;

      thead {
        display: none;
      }

      tbody,
      tr {
        display: block;
        width: 100%;
      }

      tr {
        position: relative;
        padding: 8px 12px 8px 28px;
      }

      td {
        display: flex;
        justify-content: space-between;
        gap: 10px;
        padding: 2px 0 !important;
        white-space: normal !important;
        border: none;

        &::before {
          content: attr(data-label);
          font-weight: 600;
          color: rgba(var(--v-theme-on-surface), 0.7);
          flex-shrink: 0;
        }
      }

      td.color-cell {
        position: absolute;
        top: 12px;
        left: 10px;
        padding: 0 !important;
        display: block;

        &::before {
          display: none;
        }

        .category-color-box-wrapper {
          padding-top: 0;
        }
      }

      td.title-cell {
        font-weight: 600;
      }
    }
  }
}
</style>
